import { useState, useEffect, useCallback } from "react";
import { getNotificationTemplates } from "../../../../Actions/AdminActions";
import { formatApiError } from "../../../../Actions/Utils";
import CreateTemplateForm from "./CreateTemplateForm";
import TemplatesTable from "./TemplatesTable";
import SendCampaignForm from "./SendCampaignForm";

export default function NotificationCampaign() {
  const [templates, setTemplates] = useState([]);
  const [templatesLoading, setTemplatesLoading] = useState(true);
  const [templatesError, setTemplatesError] = useState("");

  const loadTemplates = useCallback(async () => {
    setTemplatesLoading(true);
    setTemplatesError("");
    const res = await getNotificationTemplates();

    if (res?.error) {
      setTemplatesError(
        "Could not load templates. Please check your connection and reload the page."
      );
    } else if (res?.status === 200) {
      setTemplates(res.data?.items || []);
    } else {
      setTemplatesError(
        formatApiError(res?.data?.detail) ||
          res?.data?.message ||
          "Failed to load templates."
      );
    }
    setTemplatesLoading(false);
  }, []);

  useEffect(() => {
    loadTemplates();
  }, [loadTemplates]);

  return (
    <div className="p-4 sm:p-6 max-w-5xl mx-auto w-full">
      <div className="mb-6">
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900">Notifications</h1>
        <p className="text-sm text-gray-500 mt-0.5">
          Create templates and send notification campaigns to users.
        </p>
      </div>

      <div className="space-y-8">
        <CreateTemplateForm onCreated={loadTemplates} />
        <TemplatesTable templates={templates} loading={templatesLoading} />
        <SendCampaignForm
          templates={templates}
          templatesLoading={templatesLoading}
          templatesError={templatesError}
        />
      </div>
    </div>
  );
}
